import axios from '@/api/axiosInstance';

export default async function getOnGoingRealTimeActivity() {
  const response = await axios({
    url: `${process.env.NEXT_PUBLIC_API}/realTimeActivities/onGoing`,
    method: 'get',
  });
  return response.data;
}
